import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

// Stable worker setup
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PdfViewer = React.memo(({ fileUrl, token }) => {
    const [numPages, setNumPages] = useState(null);

    return (
        <Document
            file={{
                url: fileUrl,
                httpHeaders: token
                    ? { Authorization: `Bearer ${token}` }
                    : undefined,
            }}
            onLoadSuccess={({ numPages }) => setNumPages(numPages)}
            loading="Loading PDF..."
            error="Failed to load PDF"
        >
            {numPages &&
                Array.from({ length: numPages }, (_, i) => (
                    <Page key={i} pageNumber={i + 1}
                        scale={1.2}
                    />
                ))}
        </Document>
    );
}
)
export default PdfViewer;